$.fn.toggleProductContent = function() {
  let self = this

  let selector = self.attr('class');

  $(self).find('.'+selector+'__title, .'+selector+'__image-wrapper').click(function() {
    var max_height = self.find('.product-content__wrapper').outerHeight()
    self.find('.product-content').css('--max-height', max_height + 'px')
    self.toggleClass('--open')
  });

  return function() {
    return self
  }()
};
